<kendo-tabstrip #tabstripFlag [tabPosition]="'left'" (tabSelect)="onTabSelect($event)">
    <kendo-tabstrip-tab [selected]="!designMode">
        <ng-template kendoTabTitle>
            <i class="fas fa-database"></i>&nbsp;{{ 'DATA' | translate }}
        </ng-template>
        <ng-template kendoTabContent>
            <div class="row">
                <div class="col-sm-6">
                    <button class="k-button" (click)="exportToExcel()" style="margin-left:2px" [disabled]="exporting">
                        {{'EXPORT-TO-EXCEL' | translate}}<i class="k-icon k-i-loading" *ngIf="exporting"
                            style="width: 15px;"></i><i class="fal fa-file-excel" *ngIf="!exporting"
                            style="width: 15px;color:white"></i>
                    </button>
                </div>
                <div class="col-sm-6">
                    <div class="inputWithIcon inputWithIcon-search float-right d-flex mt-1">
                        <app-advanced-mode id="reportResultGridAdvancedSwitch" [storageKey]="'report-results-list'"
                            (collapsibleToggle)="toggleAdvance($event)">
                        </app-advanced-mode>
                    </div>
                </div>
            </div>
            <ng-template [ngTemplateOutlet]="filterTextTemplate"></ng-template>
            <div class="row">
                <div class="pt-2 pl-3 mb-3 w-100" [ngClass]="{'max-grid-height': parentWindowState === 'default'}"
                    style="max-width: 100%;">
                    <div class="row justify-content-center pt-2" *ngIf="exporting"
                        style="position: relative;margin-top:10%;">
                        <span class="k-icon k-i-loading kendo-loading-icon"></span>
                    </div>
                    <kendo-grid [data]="gridView" *ngIf="!exporting"
                        [pageable]="{pageSizes: pageSizes, buttonCount: 5 }" [pageSize]="state.take" [skip]="state.skip"
                        [sort]="state.sort" [loading]="loading" [filter]="state.filter" [sortable]="true"
                        [filterable]="enableAdvanced" [filter]="state.filter" [selectable]="{ mode: 'single' }"
                        [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced"
                        (dataStateChange)="dataStateChange($event, true)" (columnReorder)="onReorder($event)"
                        (columnResize)="onResize($event)" (columnVisibilityChange)="onVisibilityChange($event)"
                        [attr.disabled]="exporting ? '' : null">
                        <ng-template kendoGridToolbarTemplate [position]="'top'" *ngIf="designMode && enableAdvanced">
                            <button kendoButton (click)="resetGridColumns()" class="float-right">
                                {{'RESET-GRID-COLUMNS' | translate }}
                            </button>
                        </ng-template>
                        <ng-template kendoGridColumnMenuTemplate let-service="service">
                            <kendo-grid-columnmenu-sort [service]="service"></kendo-grid-columnmenu-sort>
                            <kendo-grid-columnmenu-chooser [service]="service"></kendo-grid-columnmenu-chooser>
                            <div class="k-columnmenu-item custom-column-selector" (click)="columnSelector(true)">
                                {{'SELECT-ALL' | translate}}</div>
                            <div class="k-columnmenu-item custom-column-selector" (click)="columnSelector(false)">
                                {{'DESELECT-ALL' | translate}}
                            </div>
                            <div class="k-columnmenu-item-wrapper"></div>
                            <kendo-grid-columnmenu-filter [service]="service"></kendo-grid-columnmenu-filter>
                        </ng-template>
                        <kendo-grid-column *ngFor="let col of view.columnsConfig" [field]="col.field"
                            [title]="col.title" [width]="col.width" [filter]="col.filter" [format]="col.format"
                            [filterable]="col.filterable !== undefined ? col.filterable : true"
                            [hidden]="col.hidden !== undefined ? col.hidden : false"
                            [class]="col.filter === 'boolean' ? 'text-center' : ''">
                            <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.filter === 'boolean'">
                                <i *ngIf="dataItem[col.field] && dataItem" class="fas fa-check">
                                </i>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.filter === 'numeric'">
                                {{dataItem[col.field]}}
                            </ng-template>
                        </kendo-grid-column>
                    </kendo-grid>
                </div>
            </div>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [selected]="designMode">
        <ng-template kendoTabTitle>
            <i class="fas fa-filter"></i>&nbsp;{{ 'FILTERS' | translate }}
        </ng-template>
        <ng-template kendoTabContent>
            <ng-template [ngTemplateOutlet]="filterTextTemplate"></ng-template>
            <div [ngClass]="{'max-filter-height': parentWindowState === 'default'}">
                <kendo-filter *ngIf="loaded" [filters]="fields" [value]="currentFilters"
                    (valueChange)="onFilterChange($event)" class="w-100">
                </kendo-filter>
            </div>
            <div class="text-center" *ngIf="!state || state.filter.filters.length === 0"
                style="color: rgba(0, 0, 0, 0.25);margin-top:-25px;">
                {{'NO-FILTERS' | translate }}
            </div>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab *ngIf="designMode">
        <ng-template kendoTabTitle>
            <i class="fas fa-function"></i>&nbsp;{{ 'FUNCTIONS' | translate }}
        </ng-template>
        <ng-template kendoTabContent>
            <div [ngClass]="{'max-function-height': parentWindowState === 'default'}">
                <button kendoButton [primary]="true" (click)="addFunction()" type="button" class="mb-2">
                    {{'ADD-FUNCTION' | translate}}<i class="far fa-plus"></i>
                </button>
                <form *ngIf="editForm && editForm.controls" novalidate [formGroup]="editForm">
                    <div formArrayName="filterFunctions">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>
                                        <label class="k-text-uppercase dark font-weight-normal">{{ 'COLUMN-NAME' |
                                            translate}} *
                                        </label>
                                    </th>
                                    <th>
                                        <label class="k-text-uppercase dark font-weight-normal">{{ 'DATA-TYPE' |
                                            translate }} *
                                        </label>
                                    </th>
                                    <th>
                                        <label class="k-text-uppercase dark font-weight-normal">{{ 'FUNCTION-CODE' |
                                            translate }} *
                                        </label>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let option of editForm.controls.filterFunctions.controls; let i=index"
                                    [formGroupName]="i">
                                    <td style="width:28%">
                                        <input kendoTextBox formControlName="name" maxlength="256" />
                                        <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="editForm.controls.filterFunctions.controls[i].controls.name.hasError('required') && 
                                               editForm.controls.filterFunctions.controls[i].controls.name.touched">
                                            {{ 'REQUIRED-COLUMN-NAME' | translate }}
                                        </div>
                                    </td>
                                    <td style="width:20%">
                                        <kendo-combobox formControlName="dataType" [data]="columnDataTypes"
                                            [textField]="'text'" [valueField]="'value'" [valuePrimitive]="true">
                                        </kendo-combobox>
                                        <div class="k-tooltip k-tooltip-validation" role="alert"
                                            *ngIf="editForm.controls.filterFunctions.controls[i].controls.dataType.hasError('required') &&
                                               editForm.controls.filterFunctions.controls[i].controls.dataType.touched">
                                            {{'REQUIRED-DATA-TYPE' | translate}}
                                        </div>
                                    </td>
                                    <td class="pr-0">
                                        <div class="mb-2">
                                            <textarea kendoTextArea rows="2" formControlName="functionCode"
                                                maxlength="4000" class="w-100" style="min-height:37px;">
                                        </textarea>
                                            <div class="k-tooltip k-tooltip-validation" role="alert"
                                                *ngIf="editForm.controls.filterFunctions.controls[i].controls.functionCode.hasError('required') &&
                                               editForm.controls.filterFunctions.controls[i].controls.functionCode.touched">
                                                {{'REQUIRED-FUNCTION-CODE' | translate}}
                                            </div>
                                        </div>
                                        <div
                                            *ngIf="editForm.controls.filterFunctions.controls[i].get('columnNameVar1').validator">
                                            <label class="k-form-field w-100">
                                                <span class="k-text-uppercase dark">
                                                    {{'VAR-1' | translate}} *
                                                </span>
                                                <kendo-combobox formControlName="columnNameVar1" [data]="fields"
                                                    [textField]="'field'" [valueField]="'field'"
                                                    [valuePrimitive]="true">
                                                </kendo-combobox>
                                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                                    *ngIf="editForm.controls.filterFunctions.controls[i].controls.columnNameVar1.hasError('required') &&
                                                       editForm.controls.filterFunctions.controls[i].controls.columnNameVar1.touched">
                                                    {{'VALIDATIONS-REQUIRED' | translate}}
                                                </div>
                                            </label>
                                        </div>
                                        <div
                                            *ngIf="editForm.controls.filterFunctions.controls[i].get('columnNameVar2').validator">
                                            <label class="k-form-field w-100">
                                                <span class="k-text-uppercase dark">
                                                    {{'VAR-2' | translate}} *
                                                </span>
                                                <kendo-combobox formControlName="columnNameVar2" [data]="fields"
                                                    [textField]="'field'" [valueField]="'field'"
                                                    [valuePrimitive]="true">
                                                </kendo-combobox>
                                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                                    *ngIf="editForm.controls.filterFunctions.controls[i].controls.columnNameVar2.hasError('required') &&
                                                       editForm.controls.filterFunctions.controls[i].controls.columnNameVar2.touched">
                                                    {{'VALIDATIONS-REQUIRED' | translate}}
                                                </div>
                                            </label>
                                        </div>
                                        <div
                                            *ngIf="editForm.controls.filterFunctions.controls[i].get('columnNameVar3').validator">
                                            <label class="k-form-field w-100">
                                                <span class="k-text-uppercase dark">
                                                    {{'VAR-3' | translate}} *
                                                </span>
                                                <kendo-combobox formControlName="columnNameVar3" [data]="fields"
                                                    [textField]="'field'" [valueField]="'field'"
                                                    [valuePrimitive]="true">
                                                </kendo-combobox>
                                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                                    *ngIf="editForm.controls.filterFunctions.controls[i].controls.columnNameVar3.hasError('required') &&
                                                           editForm.controls.filterFunctions.controls[i].controls.columnNameVar3.touched">
                                                    {{'VALIDATIONS-REQUIRED' | translate}}
                                                </div>
                                            </label>
                                        </div>
                                    </td>
                                    <td style="text-align: end; width: 90px">
                                        <kendo-dropdownbutton
                                            [disabled]="editForm.controls.filterFunctions.controls[i].controls.id.value"
                                            [data]="extractFunctions" [textField]="'displayName'"
                                            iconClass="fas fa-function" (itemClick)="copyFunctionCode($event, i)">
                                        </kendo-dropdownbutton>
                                        <a title="{{ 'DELETE' | translate }}" style="position: relative;top: 3px;"
                                            (click)="removeFunction(i,editForm.controls.filterFunctions.controls[i].controls.id.value)">
                                            <i class="fas fa-fw fa-times-circle fa-delete-custom"
                                                style="padding-top:0;">
                                            </i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="text-center" *ngIf="editForm.controls.filterFunctions.controls.length === 0"
                            style="color: rgba(0, 0, 0, 0.25);">
                            {{'NO-FUNCTIONS' | translate }}
                        </div>
                    </div>
                </form>
            </div>
        </ng-template>
    </kendo-tabstrip-tab>
</kendo-tabstrip>
<!--Filters text template-->
<ng-template #filterTextTemplate>
    <div *ngIf="filtersText" class="mt-2 mb-2" style="max-height: 100px; overflow: auto;">
        <span class="k-text-uppercase" style="color:gray;font-size:smaller">{{'RESULTS-FOR' | translate}}
            {{filtersText}}
        </span>
    </div>
</ng-template>